// @flow
import React from 'react'
import styled, { css, type StyledComponent } from 'styled-components'

const buttonStyles = css`
  background-color: white;
  &,
  &:focus {
    font-family: 'PT Sans Caption', sans-serif;
    font-size: 11px;
    color: #2da1c4;
    padding: 2px 10px;
    border: 1px solid #2da1c4;
    border-radius: 10px;
    text-decoration: none;
  }
  &:hover,
  &:active {
    text-decoration: none;
    background-image: linear-gradient(to top, #2ab3d5 0%, #2ab3d5 100%);
    color: #fff;
  }
  &:active {
    box-shadow: inset rgba(0, 0, 0, 0.3) 0 1px 3px 0;
  }
`
const Link: StyledComponent<Object, any, any> = styled.a`
  ${buttonStyles};
`
const Button: StyledComponent<Object, any, any> = styled.button`
  ${buttonStyles};
  cursor: pointer;
`

export default ({ onClick, href, className, children, ...props }: Object) => {
  let clicked = (e) => {
    e.preventDefault()
    onClick()
  }

  const ButtonComponent = href ? Link : Button

  return (
    <ButtonComponent
      href={href}
      className={className}
      onClick={(e) => onClick && clicked(e)}
      {...props}
    >
      {children}
    </ButtonComponent>
  )
}
